// What happened in this tab, kept in memory only: the pages visited and the
// browser errors seen, for the admin bug report (components/admin/BugReporter).
// Nothing here is sent anywhere until someone files a report.

export interface TrailPage { path: string; at: number }
export interface TrailError { kind: string; message: string; path: string; at: number }

const MAX_PAGES = 20;
const MAX_ERRORS = 10;
const pages: TrailPage[] = [];
const errors: TrailError[] = [];

export function notePage(path: string, at = Date.now()) {
  if (pages[pages.length - 1]?.path === path) return;
  pages.push({ path, at });
  if (pages.length > MAX_PAGES) pages.shift();
}

export function noteError(kind: string, message: string, at = Date.now()) {
  const path = typeof location !== "undefined" ? location.pathname : "";
  errors.push({ kind, message: message.slice(0, 200), path, at });
  if (errors.length > MAX_ERRORS) errors.shift();
}

export const trail = () => ({ pages: [...pages], errors: [...errors] });

/** Test hook. */
export const resetTrail = () => { pages.length = 0; errors.length = 0; };
